import { render, staticRenderFns } from "./ArceWizard.vue?vue&type=template&id=12037fd0&scoped=true&"
import script from "./ArceWizard.vue?vue&type=script&lang=js&"
export * from "./ArceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12037fd0",
  null
  
)

export default component.exports